import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { VISIBLE_CANCEL_STATUS_DETAILS } from 'constants/order.constants';
import {
  AdditionalOrderColumn,
  CallbackUrlStatus,
  FilterDefinitionType,
  OrdersTab,
  OrderStatusReason,
} from 'enums';
import { useOrderQueryFilters, useUserContext } from 'hooks';
import { TranslationNamespace } from 'i18n';
import { FilterDefinition, OrderFilters } from 'types';
import { orderUtils } from 'utils';

import { ManageOrdersList } from '../ManageOrderList';

export const CancelledOrders: React.FC = () => {
  const { t: tFilters } = useTranslation(TranslationNamespace.Common, {
    keyPrefix: 'features.orders.filters',
  });

  const { orderStatusReasons } = useUserContext();
  useOrderQueryFilters();

  const additionalFilters: FilterDefinition<OrderFilters>[] = useMemo(
    () => [
      {
        label: tFilters('callback_url_status'),
        name: 'callbackUrlStatus',
        type: FilterDefinitionType.Enum,
        enum: CallbackUrlStatus,
        getDisplayName: orderUtils.getCallbackUrlStatusLabel,
      },
      {
        label: tFilters('cancel_reason'),
        name: 'statusDetails',
        type: FilterDefinitionType.Enum,
        enum: VISIBLE_CANCEL_STATUS_DETAILS,
        getDisplayName: orderUtils.getStatusDetailsLabel,
      },
      {
        label: tFilters('status_reason'),
        name: 'statusReason',
        type: FilterDefinitionType.Enum,
        enum: orderStatusReasons,
        getDisplayName: (value: OrderStatusReason) =>
          orderUtils.getStatusReasonLabel(value),
      },
    ],
    [orderStatusReasons, tFilters],
  );

  return (
    <ManageOrdersList
      tab={OrdersTab.Cancelled}
      additionalColumns={[
        AdditionalOrderColumn.CancelReason,
        AdditionalOrderColumn.CancelledToDispute,
        AdditionalOrderColumn.OrderProcessedBy,
        AdditionalOrderColumn.Validation,
      ]}
      additionalFilters={additionalFilters}
    />
  );
};
